import React from "react";
import { Col, Row, Button } from "antd";
import { Link } from "react-router-dom";

import PracticalGuidesImage from "../../../assets/images/guias-praticos-cross-content@2x.png";

import "./PracticalGuidesCTA.css";

const PracticalGuidesCTA = () => {
  return (
    <Row className="cta_guides pb-100 pt-100">
      <Col span={24} className="container">
        <div className="card">
          <Row gutter={[24, 24]}>
            <Col xs={24} sm={24} md={15} lg={15} xl={15} className="pl-80 pt-20 pb-20 d-flex flex-column jc-center">
              <p className="f-44 white bold">Guias Práticos, na ajuda à prática clínica</p>
              <Link to="/guias-praticos" className="mt-20">
                <Button size="large" type="primary" className="mt-20">
                  Ver mais
                </Button>
              </Link>
            </Col>
            <Col xs={24} sm={24} md={9} lg={9} xl={9} className="d-flex jc-end ai-end">
              <img src={PracticalGuidesImage} className="w-100" style={{ height: "auto" }} />
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default PracticalGuidesCTA;
